import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Toast } from '@/shared/components/toast/toast';

/**
 * Raiz da aplicação: hospeda o roteador e o toast que atende quem publica mensagem sem ter um
 * `<app-toast>` na própria tela (o `MessageService` da raiz).
 */
@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, Toast],
    template: `
        <app-toast />
        <router-outlet></router-outlet>
    `
})
export class AppComponent {}
